export const menuData = [
  { title: "Features", link: "/features" },
  { title: "About", link: "/about" },
  { title: "Pricing", link: "/pricing" },
  { title: "Support", link: "/support" },
]
